import moment from 'moment'
import {filters} from '@/filters'
import {
  CELL_BORDER, COLORS, MONEY_FORMAT, USD_FORMAT,
  amountFormat, createWorkbook, downloadWorkbook, styleHeaderRow,
} from '@/excel'

/**
 * Builds and downloads an .xlsx of the material remains report as shown on the page.
 * @param rows       report rows
 * @param totals     {remain} from the API
 * @param toDate     report date (server format)
 * @param materials  names of the materials selected in the filter (empty = all)
 */
export async function exportMaterialReport({rows, totals, toDate, materials = []}) {
  const workbook = await createWorkbook()
  const sheet = workbook.addWorksheet('Остаток материалов', {
    views: [{state: 'frozen', ySplit: materials.length ? 5 : 4, showGridLines: false}],
  })

  sheet.columns = [
    {width: 6},
    {width: 40},
    {width: 8},
    {width: 14},
    {width: 14},
    {width: 13},
    {width: 11},
    {width: 13},
    {width: 14},
    {width: 15},
    {width: 18},
  ]

  sheet.addRow(['Отчет по остатку материалов']).font = {bold: true, size: 14}
  sheet.addRow([`К дате: ${filters.date(toDate)}`]).font = {italic: true}
  if (materials.length) {
    const row = sheet.addRow([`Материалы: ${materials.join(', ')}`])
    row.font = {italic: true}
  }
  sheet.addRow([])

  styleHeaderRow(sheet.addRow([
    '№', 'Название', 'Ед. изм.', 'Приход', 'Расход', 'Цена, сум', 'Цена, $',
    'Посл приёмка', 'Остаток', 'Цена остатка, сум', 'Сумма остатка, сум',
  ]))

  rows.forEach((item, index) => {
    const row = sheet.addRow([
      index + 1,
      item.name,
      (item.measurement || {}).name || '',
      item.priyomka_elements_total,
      item.rasxod_elements_total,
      item.buy_price_last,
      item.buy_price_usd_last,
      item._last_priyomka === 'usd' ? 'в долл' : 'в сумах',
      item.remain,
      item.buy_price_by_currency,
      item.remain_price,
    ])

    row.getCell(1).alignment = {horizontal: 'center'}
    row.getCell(3).alignment = {horizontal: 'center'}
    row.getCell(8).alignment = {horizontal: 'right'}
    ;[4, 5, 9].forEach(i => row.getCell(i).numFmt = amountFormat(row.getCell(i).value))
    ;[6, 10, 11].forEach(i => row.getCell(i).numFmt = MONEY_FORMAT)
    row.getCell(7).numFmt = USD_FORMAT

    // Same highlight as on the page: remain at or below the notification threshold
    if (item.remain <= item.min_notified_amount) {
      row.getCell(9).font = {bold: true, color: {argb: COLORS.red}}
    }

    row.eachCell({includeEmpty: true}, cell => cell.border = CELL_BORDER)
  })

  const totalRow = sheet.addRow([null, 'Итого остаток, сум:', null, null, null, null, null, null, null, null, totals.remain || 0])
  totalRow.font = {bold: true}
  totalRow.getCell(11).numFmt = MONEY_FORMAT

  await downloadWorkbook(workbook, `Остаток материалов ${moment(toDate).format('YYYY-MM-DD')}.xlsx`)
}
